import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as projectActions from '../actions/projectActions';
import MarkdownField from './MarkdownField';
import {mergeProjectIntroMarkup} from './PageProjectDetail';
import ProgramBanner from './ProgramBanner';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


class ProjectStub extends React.Component{
  componentDidMount(){
    // List pages already hydrate stubs via loadProjectManySuccess — skip the heavy detail refetch.
    if(this.props.project?.cmsName) return;
    this.props.actions.initProject(this.props.cmsId);
  }


  projectUrl(){
    return `/projects/${this.props.project.slug}`;
  }


  renderDescription(){
    const markup = mergeProjectIntroMarkup(this.props.project);
    if(!markup) return null;

    const teaser = helpers.extractMarkdownTeaser(
      markup,
      apiValues.PROJECT_STUB_DESCRIPTION_LENGTH,
    );
    if(!teaser) return null;

    return (
      <MarkdownField className="project-stub__description"
                     markup={teaser}/>
    );
  }
  renderProgramBanner(){
    if(this.props.hideLabel ||
       !this.props.project.program) return null;

    return (<ProgramBanner className="project-stub__program-label" program={this.props.project.program}/>);
  }
  renderThumbnail(){
    if(!this.props.project.thumbnail) return null;

    return (
      <span className='project-stub__thumbnail'>
        <img alt="" className="project-stub__thumbnail-img" src={apiValues.imgPath(this.props.project.thumbnail.url)}/>
      </span>
    );
  }
  renderTitle(){
    if(!this.props.project.title) return null;

    return (<h2 className='project-stub__title'>{this.props.project.title}</h2>);
  }
  renderCardBody(){
    return (
      <>
        {this.renderThumbnail()}
        {this.renderProgramBanner()}
        {this.renderTitle()}
        {this.renderDescription()}
      </>
    );
  }
  render(){
    // console.log(`ProjectStub render`, this.props);
    if(!this.props.project ||
       !this.props.project.cmsName) return null;

    const className = `project-stub ${this.props.className || ''}`.trim();

    if(this.props.project.slug) {
      return (
        <div className={className}>
          <SuperLink to={this.projectUrl()}
                     className="project-stub__link">
            {this.renderThumbnail()}
            {this.renderProgramBanner()}
            {this.renderTitle()}
          </SuperLink>
          {this.renderDescription()}
        </div>
      );
    }

    return (
      <div className={className}>
        {this.renderCardBody()}
      </div>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => ({
    project: helpers.getById(state.project, ownProps.cmsId),
  }),
  (dispatch) => ({
    actions: bindActionCreators(projectActions, dispatch),
  }),
)(ProjectStub));


ProjectStub.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  project: PropTypes.object,
};
